module.exports = __webpack_public_path__ + "static/media/texture-wood-white-v.ccdae60b.jpg";